import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { FindAStoreCTA, BookAppointmentCTA, PricedAddToCartCTA } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { mapLensesToDraftLineItem } from '../utils.js';

const CTAButton = ({ onPrescriptionClick , handleMiniCartChange , isPrescriptionEnabled , isCLBBSubscription , calculatedDiscountPrice , calculatedPrice , lineItemsForCart , excludedFromCheckout , hasLenses , hasNonOrderableProduct , onClick , pricePerMonth , handleConversionEvent , isQuantityDiscountSelected ,  })=>{
    const { getLabel  } = useIntl();
    const { routes  } = useProductDetailContext();
    const storesRoute = routes.stores;
    const addToCartCallback = React.useCallback(()=>{
        handleMiniCartChange && handleMiniCartChange();
        onClick && onClick();
    }, [
        handleMiniCartChange,
        onClick
    ]);
    if (excludedFromCheckout || hasNonOrderableProduct) {
        return /*#__PURE__*/ React.createElement(FindAStoreCTA, {
            href: storesRoute,
            onNavigate: handleConversionEvent
        });
    }
    if (!isPrescriptionEnabled) {
        return /*#__PURE__*/ React.createElement(BookAppointmentCTA, {
            href: storesRoute,
            onNavigate: handleConversionEvent
        });
    }
    /*
   * If CLBB subscription product and configuration is valid, show button with monthly costs that triggers the MiniCart
   * */ if (isCLBBSubscription && hasLenses) {
        // CLBB Add To Cart
        return /*#__PURE__*/ React.createElement(PricedAddToCartCTA, {
            priceInterval: "monthly",
            isCentAmount: true,
            price: pricePerMonth === null || pricePerMonth === void 0 ? void 0 : pricePerMonth.centAmount,
            onSuccess: addToCartCallback,
            lineItemDrafts: mapLensesToDraftLineItem(lineItemsForCart, 'contact-lenses-bundle-benelux'),
            "data-t": "btn-subscription",
            isQuantityDiscountSelected: isQuantityDiscountSelected
        });
    }
    if (isPrescriptionEnabled && hasLenses) {
        // Single-purchase CL Add to Cart
        return /*#__PURE__*/ React.createElement(PricedAddToCartCTA, {
            isCentAmount: true,
            price: calculatedDiscountPrice ? calculatedDiscountPrice : calculatedPrice,
            onSuccess: addToCartCallback,
            lineItemDrafts: mapLensesToDraftLineItem(lineItemsForCart, 'contact-lenses'),
            isQuantityDiscountSelected: isQuantityDiscountSelected
        });
    }
    // Dummy button that always triggers form validations
    return /*#__PURE__*/ React.createElement(Button, {
        className: "add-to-cart",
        caption: getLabel('products.actions.addToCart'),
        "data-t": "btn-enter-prescription",
        onClick: onPrescriptionClick
    });
};

export { CTAButton };
//# sourceMappingURL=CTAButton.js.map
